import { render, staticRenderFns } from "./ComplaintGroupDetail.vue?vue&type=template&id=0c96e44d&"
import script from "./ComplaintGroupDetail.vue?vue&type=script&lang=js&"
export * from "./ComplaintGroupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports